import { Box, Divider, Grid, GridSize, Typography } from '@mui/material';
import RenderElement from './RenderElement';

interface Props {
    keyValuePair: any,
    [x:string]: any
    containerColumn?: boolean | GridSize | undefined
    keyColumn?: boolean | GridSize | undefined
    valueColumn?: boolean | GridSize | undefined
    title?: string,
    split?: number,
    noBorder?: boolean
}

const KeyValueGrid = (props: Props) => {
    const { title, keyValuePair, containerColumn = 4, keyColumn= 5, valueColumn = 7, split, noBorder = false, ...rest } = props;

    const Values = Object.keys(keyValuePair)
    let Data = [Values];
    if(split) {
        const slice0 = Values.slice(0, split);
        const slice1 = Values.slice(split);
        Data = [slice0, slice1]
    }

  return (
    <Grid container {...rest} >
        <Grid item sm={containerColumn}>
            <Box border={noBorder ? 0 : 1} borderColor="divider" borderRadius={0.5} px={ noBorder ? 0 : 3} pt={noBorder ? ((!!title) ? 1 : 0) : 1} pb={1}>
                <RenderElement show={!!title}>
                    <Typography variant="h6" fontWeight={600} mb={0.5}>{title}</Typography>
                </RenderElement>
                <Grid container columnSpacing={3}>
                    {
                        Data?.map((keys, i) => (
                            <Grid item sm={Data.length === 1 ? 12: 6} key={`slice-${i}`}>
                                {
                                    keys.map((key: any, index: number)=> (
                                        <Box key={key}>
                                            <Grid container sx={{ py: 1 }} overflow="hidden">
                                                <Grid item sm={keyColumn}>
                                                    <Typography  fontWeight={500} color="grey.600">{key}</Typography>
                                                </Grid>
                                                <Grid item sm={valueColumn}>
                                                    <RenderElement show={typeof keyValuePair[key] === 'string'}>
                                                        <Typography  fontWeight={500} sx={{ lineBreak: 'anywhere' }}>{keyValuePair[key] || '-'}</Typography>
                                                    </RenderElement>
                                                    <RenderElement show={typeof keyValuePair[key] !== 'string'}>
                                                        {keyValuePair[key]}
                                                    </RenderElement>
                                                </Grid>
                                            </Grid>
                                            <RenderElement show={!(index === keys.length-1) || noBorder}>
                                                <Divider />
                                            </RenderElement>
                                        </Box>
                                    ))
                                }
                            </Grid>
                        ))
                    }
                </Grid>
            </Box>
        </Grid>
    </Grid>
  )
}

export default KeyValueGrid